export default {
  eyebrow: 'Help centre',
  title: 'How can we help?',
  subtitle: 'Find answers to common questions',
  search: {
    placeholder: 'Search FAQs...',
  },
  noResults: 'No matches for "{query}".',
  topics: {
    label: 'Topics',
    all: 'All',
    general: 'General',
  },
  contact: {
    title: 'Still need help?',
    body: 'Write to us and include your order ID if you have one.',
    emailSupport: 'Email support',
  },

  sections: {
    purchasing: {
      title: 'Purchasing & payment',
      items: [
        {
          q: 'How do I pay with the wallet?',
          a: [
            'Top up your wallet from Account → Billing, then place an order from your cart. The order total is deducted from the available balance.',
          ],
        },
        {
          q: 'What payment methods do you support for top-ups?',
          a: [
            'Wallet top-ups go through our hosted payment provider; the methods currently accepted are listed in the footer. Your card details never touch our servers.',
          ],
        },
        {
          q: 'Why did my payment fail?',
          a: [
            'Most common reasons: insufficient funds, 3-D Secure declined, or a country mismatch with your card issuer. Try a different card or contact support with your order ID.',
          ],
        },
      ],
    },
    activation: {
      title: 'Key activation',
      items: [
        {
          q: 'How do I activate a Steam key?',
          a: [
            'Open the Steam client and log into your account.',
            'Click on "Games Menu" at the top left and choose "Activate a Product on Steam…"',
            'Follow the onscreen instructions and paste your purchased key when prompted.',
          ],
        },
        {
          q: 'How long are keys stored in my account?',
          a: [
            'Keys remain visible in your order detail page for 24 hours after delivery. They are always emailed to you immediately as well — save that email as a permanent record.',
          ],
        },
        {
          q: "What if my key doesn't work?",
          a: [
            'Contact support with your order ID. We will verify with the supplier and either issue a replacement key or refund your wallet.',
          ],
        },
        {
          q: 'Can I activate keys in different regions?',
          a: [
            'Each product lists its activation region (e.g. EU, Global). A region-locked key activates only on accounts registered in that region. The catalog filters let you narrow down by region.',
          ],
        },
      ],
    },
    account: {
      title: 'Account management',
      items: [
        {
          q: 'How do I verify my email?',
          a: [
            'When you sign up we send a confirmation link to the address on file. Click it to verify. If it expired, use "Resend verification email" from your dashboard.',
          ],
        },
        {
          q: 'What is KYC and when do I need it?',
          a: [
            'KYC is identity verification. It is required to make individual purchases over €50, as part of EU compliance. Submit your details from Account → Settings → Security & KYC.',
          ],
        },
        {
          q: 'How do I change my password?',
          a: [
            'Open Account → Settings → Password, then enter your current password and the new one. All other sessions are signed out after a password change.',
          ],
        },
        {
          q: 'Can I delete my account?',
          a: [
            "Yes. Contact support{'@'}keyzostore.com from the email on file and ask for deletion. We complete the request within 14 days as required by GDPR.",
          ],
        },
      ],
    },
    refunds: {
      title: 'Refunds & disputes',
      items: [
        {
          q: "What's the refund policy?",
          a: [
            'Unrevealed keys can be refunded to your wallet at any time. Once a key is revealed it is considered consumed and is non-refundable — except in cases of supplier defect.',
          ],
        },
        {
          q: 'How do I report a defective key?',
          a: [
            'Open your order page and click "Report issue". Provide the activation error message and a screenshot if possible. We escalate to the supplier within one business day.',
          ],
        },
        {
          q: 'How long do refunds take?',
          a: [
            'Wallet refunds are instant. Refunds back to the original payment method take 5–10 business days depending on your bank.',
          ],
        },
      ],
    },
  },
};
